import React from 'react'

const WorkspaceStatus = (props) => {
  const { status } = props;
  let color = "#FF9831";
  if (status === "Submitted" || status === "Published") {
    color = "#35A4E8";
  }
  if (status === "Deployed") {
    color = "#57E188";
  }
  if (status === "Inactive") {
    color = "#B9251C";
  }
  if (status === "Processed" || status === "Published" || status === "Active" || status === "Approved") {
    color = "#168736";
  }
  if(!status) {
    return <p>NA</p>
  }
  return (
    <div className="flex gap-2 items-center py-2">
      <div className={`rounded-full w-3 h-3`} style={{ backgroundColor: color }}></div>
      <p className="!capitalize">{status}</p>
    </div>
  )
}

export default WorkspaceStatus